enum VisibilityEnum {
    Normal = 0,
    Deprecated = 1
}

enum LabelFormatEnum {
    Automatic,
    Normal,
    Thousands,
    Millions,
    Billions,
}

function labelFormatEnumToString(enumValue: LabelFormatEnum) {
    return LabelFormatEnum[enumValue];
}

interface IDateVariation {
    id: string;
    text: string;
    range: boolean;
}
var getFilterVariables = function (): Array<IDateVariation> {
    return [
        { id: "DATE", text: "Date", range: false },
        { id: "DAY", text: "Day", range: false },
        { id: "MONTH", text: "Month", range: false },
        { id: "YEAR", text: "Year", range: false },
        { id: "STARTLONGDATE", text: "Long Date", range: false },
        { id: "STARTYEAR", text: "Start Year", range: true },        
        { id: "STARTMONTH", text: "Start Month", range: true },
        { id: "STARTDAY", text: "Start Day", range: true },
        { id: "STARTDATE", text: "Start Date", range: true },
        { id: "STARTLONGDATE", text: "Start Long Date", range: true },
        { id: "ENDYEAR", text: "End Year", range: true },
        { id: "ENDMONTH", text: "End Month", range: true },
        { id: "ENDDAY", text: "End Day", range: true },
        { id: "ENDDATE", text: "End Date", range: true },
        { id: "ENDLONGDATE", text: "End Long Date", range: true },
        { id: "DATERANGE", text: "Date Range", range: undefined},
        { id: "DATERANGESHORT", text: "Short Date Range", range: undefined },
        { id: "MTH", text: "Short Month", range: undefined },
        { id: "ENDMTH", text: "Short End Month", range: true },
        { id: "WEEK", text: "Week", range: undefined },
        { id: "WEEKRANGE", text: "Week Range", range: true }
    ];
}

enum TabTypeEnum {
    Report = 0,
    Dashboard = 1,
    ReportDesigner = 2,
    ChartDesigner = 3,
    None = 4,
    Chart = 5
}

enum WorkbookOpeningModeEnum {
    View = 0,
    Edit = 1
}

enum EmailFormatEnum {
    PDFLandscape = "PDFLandscape",
    PDF = "PDF",
    EmailBody = "EmailBody",
    Excel = "Excel",
    CSV = "CSV",
    ExcelWithoutHeaders = "ExcelWithoutHeaders",
    CSVWithoutHeaders = "CSVWithoutHeaders",
    Image = "Image"
}